import React, { useEffect } from 'react';
import './Lightbox.css';

const Lightbox = ({ media, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target.id === 'lightbox-modal') {
      onClose();
    }
  };

  return (
    <div id="lightbox-modal" className="lightbox-modal active" onClick={handleBackdropClick}>
      <div className="lightbox-content">
        {media.isVideo ? (
          <video controls>
            <source src={media.url} type="video/mp4" />
          </video>
        ) : media.isDocument ? (
          <div className="document-viewer">
            <div className="document-icon-large">📄</div>
            <p>{media.name}</p>
            <p style={{ fontSize: '0.9rem', marginTop: '10px', color: '#d4a5d4' }}>
              <a href={media.url} target="_blank" rel="noopener noreferrer" style={{ color: '#ff69b4' }}>
                Open Document
              </a>
            </p>
          </div>
        ) : (
          <img src={media.url} alt={media.name} />
        )}
        <span className="lightbox-close" onClick={onClose}>
          ×
        </span>
      </div>
    </div>
  );
};

export default Lightbox;
